let cache = {};
export class MemoryCache {
    async init() {
        return;
    }
    async setItem(key, value) {
        cache[key] = value;
    }
    async getItem(key) {
        return cache[key] ?? null;
    }
    async getItems(keys) {
        const results = new Map();
        for (const key of keys) {
            results.set(key, cache[key] ?? null);
        }
        return results;
    }
    async setItems(entries) {
        for (const [key, value] of entries) {
            cache[key] = value;
        }
    }
    async removeItem(key) {
        delete cache[key];
    }
    async clear() {
        cache = {};
    }
}
//# sourceMappingURL=MemoryCache.js.map